// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__bXkvV","ldsSpinner":"Loader_ldsSpinner__wi8LZ"};